module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/schedule-2-4-0dd95f93a0bf0811500cbd940d888547.jpg";